import {GovNavItem} from "@gov-design-system-ce/react";
import React, {MouseEvent} from "react";

const IS_ACTIVE_CLASS = "is-active";

export interface NavItemProps {
    active?: boolean
    onClick?: (event: MouseEvent) => void;
    children: React.ReactNode;
}

export default function NavItem(props: Readonly<NavItemProps>) {
    const {children, active, onClick} = props;

    return (
        <GovNavItem className={active ? IS_ACTIVE_CLASS : ""}
                    onClick={onClick} >
            {children}
        </GovNavItem>
    );
}
